import { render, staticRenderFns } from "./ManterPerfilTurmaView.vue?vue&type=template&id=0a8bbc7a"
import script from "./ManterPerfilTurmaView.vue?vue&type=script&lang=js"
export * from "./ManterPerfilTurmaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports